import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../../icon.component';
import { JobCatsOne } from '../../vacancy-data.component';
import { JobsNavigationService } from '../jobs-navigation.service';

@Component({
  selector: 'app-featured-jobs-list',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './featured-jobs-list.component.html',
  styleUrls: ['./featured-jobs-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedJobsListComponent {
  @Input({ required: true }) jobs: JobCatsOne[] = [];
  @Input({ required: true }) title!: string;
  @Input() ctaLabel?: string;
  @Input() ctaHref?: string | unknown[];

  constructor(private readonly nav: JobsNavigationService) {}

  public onJobClick(job: JobCatsOne): void {
    this.nav.navigateToJob(job);
  }

  public jobLocation(job: JobCatsOne): string {
    return this.nav.getJobLocation(job);
  }

  public jobSalary(job: JobCatsOne): string {
    return this.nav.getJobSalary(job);
  }

  public get ctaRouterLink(): unknown[] | null {
    if (Array.isArray(this.ctaHref)) return this.ctaHref;
    if (typeof this.ctaHref === 'string' && this.ctaHref.startsWith('/')) {
      return [this.ctaHref];
    }
    return null;
  }

  public get ctaExternalHref(): string | null {
    if (typeof this.ctaHref === 'string' && !this.ctaHref.startsWith('/')) {
      return this.ctaHref;
    }
    return null;
  }
}
